export enum DraftActionsType {
  CONFIGURATION,
  EXTERNAL_CONFIGURATION,
  SECTION
}
